module.exports = __webpack_public_path__ + "static/img/photo_3.34d517a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_bole/photo_3.jpg
// module id = uwLD
// module chunks = 1